<template>
  <span dir="ltr">{{h}} : {{m}} : {{s}}</span>
</template>

<script>
export default {
  name: "number",
  methods:{
    calculateTimes(time)
    {
      const currentDate = new Date();
      time = time - currentDate.getTime();
      const output = {h: 0, m: 0, s: 0};
      if (time <0)
        return
      time = parseInt(time / 1000);
      output.s = parseInt(time % 60);
      time = time - output.s;
      output.m = parseInt((time % 3600)/60);
      time = time - (output.m * 60);
      output.h = parseInt(time / 3600);


      output.s = output.s.toString();
      output.m = output.m.toString();
      output.h = output.h.toString();

      if (output.h.toString().length < 2)
        output.h = '0' + output.h;
      if (output.m.toString().length < 2)
        output.m = '0' + output.m;
      if (output.s.toString().length < 2)
        output.s = '0' + output.s;

      this.h = output.h;
      this.m = output.m;
      this.s = output.s;
    },
    render:function ()
    {
      this.time--;
    }
  },
  data:function ()
  {
    return {
      h:'00',
      m:'00',
      s:'00',
      time : 0,
    }
  },
  watch: {
    time: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.time--;
            this.calculateTimes(this.time);
            if (this.time <= 0)
              clearTimeout();
          }, 1000);
        }

      },
      immediate: true // This ensures the watcher is triggered upon creation
    }

  },
  mounted()
  {
    this.time = parseInt(this.number);
    this.render();
  },
  props:['number']
}
</script>

<style scoped>

</style>